import React from 'react';
import AnimatedSplashScreen from './sections/main-splash-screen/AnimatedSplashScreen';
import UniqueSection from './sections/UniqueSection';
import ArenaSection from './sections/ArenaSection';
import Web3Section from './sections/Web3Section';

export default function GamingPage() {
  return (
    <div data-cy='gaming-page'>
      <AnimatedSplashScreen />
      <ArenaSection data-cy='arena-section' />
      <UniqueSection data-cy='unique-section' />
      <Web3Section data-cy='web3-section' />
    </div>
  );
}
